exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-ff6dccd0]{margin-top:35px}.handle[data-v-ff6dccd0]{float:left}.close[data-v-ff6dccd0],.handle[data-v-ff6dccd0]{padding-top:8px;padding-bottom:8px}.close[data-v-ff6dccd0]{float:right}input[data-v-ff6dccd0]{display:inline-block;width:50%}.text[data-v-ff6dccd0]{margin:20px}", ""]);

// exports
